<template>
  <div id="table-result" class="py-5">
    <table id="query-table"
           class="table query-table-ui marine allow-drop-off"
           :class="{dragging: dragging, 'full-width': columnHeaders.length > 6}"
           cellspacing="0"
           cellpadding="0">
      <thead id="query-table-header" @dragover.prevent @drop.prevent="onDropColums">
        <tr class="axis" :class="{required: (required && required.columns) || (blocked && blocked.columns)}">
          <th></th>
          <th v-if="columnsAwaitingData"><app-load-content :loading="true" style="min-height: 40px" /></th>
          <th v-else-if="columnHeaders.length === 0" class="empty" :colspan="columnsCount">{{ draggingPlaceHolderText }}</th>
          <th v-else
              v-for="(header, index) in columnHeaders"
              :key="`column-headers-${header.axisLabel}-${index}`"
              @click="() => setOrderBy(header)"
              v-tooltip="isDefault(header) ? isMostRecentRange(header) ? $t('time_periods.most_recent_range') : sortTooltipText : isMostRecentRange(header) ? $t('time_periods.most_recent_range') : null"
              :class="{ 'highlighted-col': header.type === 'tag' || header.type === 'tag_filter' || header.type === 'category' }"
          >
          <div class="cell-content mr5">
              <small class="d-block text-muted" v-if="header.range && Array.isArray(header.range.values)" :style="{marginTop: '-2rem'}">{{header.range.values.map(d => formatDateRanges(d)).join(' ' + $t('time_periods.to') + ' ')}} <i v-if="header.range.mostRecentRange" class="fa fa-calendar-plus-o text-success" aria-hidden="true"></i></small>
              <span class="mr5">
                {{ header.axisLabel }}
                <span
                  v-if="
                    header &&
                    header.axisLabel &&
                    header.axisLabel.toUpperCase() === AVE_LABEL
                  "
                >
                  ({{ (!query || !query.ave_currency || projectId == query.project_id) ? projectCurrency : query.ave_currency }})
                </span>
                <span v-if="header.tag_id === 'all'">
                  - {{ header.category_name }}
                </span>
              </span>
              <i
                v-if="
                  header.axisLabel &&
                  header.type === FILTER_TYPE_TAG &&
                  columnsHaveTags
                "
                class="fas fa-times remove-tag"
                @click.prevent="removeElement({ entity: 'columns', item: header })"
              ></i>

              <span class="actions" v-if="isDefault(header)">
                  <i :class="sortIconClass"></i>
              </span>
            </div>
          </th>
          <th v-if="columns.length > 0" width="20">
            <span>
               <i class="fas fa-times pull-right remove-all" @click="deleteColumns"></i>
            </span>
          </th>
        </tr>
      </thead>

      <tbody id="query-table-body" @dragover.prevent @drop.prevent="onDropRows">
        <tr v-for="i in rowsCount" :key="'row-body-'+i">
          <td v-for="j in (noData ? (i === 1 ? 2 : 1) : i === 1 || (rowHeaders.length > 0 && !rowsAwaitingData) ? columnsCount + 1 : columnsCount)" :key="'col-body-'+i+'-'+j"
              :class="{ required: (required && required.rows) || (blocked && blocked.rows),
                        axis: ((i === 1 && j === 1 && (rowHeaders.length === 0 || rowsAwaitingData)) || (j === 1  && rowHeaders.length > 0 && !rowsAwaitingData)),
                        empty: (i === 1 && j === 1 && (rowHeaders.length === 0 || rowsAwaitingData)),
                        'align-center': (j === 2 && noData),
                        'highlighted-row': j === 1 && rowHeaders.length > 0 && !rowsAwaitingData && (rowHeaders[i-1].type === 'tag' || rowHeaders[i-1].type === 'tag_filter' || rowHeaders[i-1].type === 'category') }"
              :rowspan="(i === 1 && j === 1  && (rowHeaders.length === 0 || rowsAwaitingData)) || (j === 2 && noData) ? rowsCount : 1"
              :colspan="i === 1 && j === 2 && noData ? (columns.length > 0 ? columnsCount + 1 : columnsCount) : 1"
          >
            <span v-if="runIsBusy && rowsAwaitingData && i === 1 && j === 1"><app-load-content :loading="true" style="position: relative" /></span>
            <span v-else-if="i === 1 && j === 1 && rowHeaders.length === 0">{{draggingPlaceHolderText}}</span>
            <span
              v-else-if="j === 1 && rowHeaders.length > 0 && !rowsAwaitingData"
              v-tooltip="`${rowHeaders[i-1].axisLabel} ${ rowHeaders[i-1].tag_id === 'all' ? ' - '+rowHeaders[i-1].category_name : '' }`"
            >
              <i
                v-if="
                  rowHeaders[i-1].axisLabel &&
                  rowsHaveTags
                "
                class="fas fa-times remove-tag"
                @click.prevent="removeElement({ entity: 'rows', item: rowHeaders[i-1] })"
              ></i>
              {{rowHeaders[i-1].axisLabel}}
              <span v-if="rowHeaders[i-1].tag_id === 'all'">
                - {{ rowHeaders[i-1].category_name }}
              </span>
            </span>
            <span v-else-if="j === 2 && noData">{{$t(noDataError || 'no_data')}}</span>
            <span v-else-if="tableData && Object.keys(tableData).length > 0 && rowHeaders.length > 0 && columnHeaders.length > 0 && rowHeaders[i-1] && columnHeaders[j-2] && !rowsAwaitingData"
                  class="link-pointer"
                  v-on:click="() => openArticleList({rowHeader: rowHeaders[i-1], columnHeader: columnHeaders[j-2]})">
              {{tableData[rowHeaders[i-1].axisLabel + "_" + (i-1)][columnHeaders[j-2].axisLabel + "_" + (j-2)]}}
            </span>
          </td>
          <td v-if="columns.length > 0 && !noData" width="20">
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import LoadContent from '../load-content';
  import { QUERIES } from '../../config/const';

  import _ from 'lodash';
  import moment from 'moment';

  export default {
    components: {
      'app-load-content': LoadContent,
    },
    props: {
      query: {
        type: Object,
        required: () => true
      },
      columns: {
        type: Array,
        default: () => []
      },
      queryOutputs: {
        type: Array,
        default: () => []
      },
      rows: {
        type: Array,
        default: () => []
      },
      required: {
        type: Object,
        default: () => {}
      },
      blocked: {
        type: Object,
        default: () => {}
      },
      onDrop: {
        type: Function,
        default: () => null
      },
      dragging: {
        type: Boolean,
        default: false
      },
      queryResult: {
        type: Object,
        required: true
      },
      queryPagination: {
        type: Object,
        required: true
      },
      outputs: {
        type: Array,
        default: () => []
      },
      localTextOptions: {
        type: Array,
        default: () => []
      }
    },

    computed: {
      ...mapState({
        fullCategory: state => state.queryBuilder.category.fullCategory,
        fullStandardBreakdown: state => state.queryBuilder.standardBreakdown.fullStandardBreakdown,
        runIsBusy: state => state.queryBuilder.query.run.isBusy
      }),
      ...mapGetters({
        projectCurrency: "projects/projectCurrency",
      }),

      FILTER_TYPE_TAG() {
        return QUERIES.FILTER_TYPE.TAG;
      },

      AVE_LABEL() {
        return QUERIES.AVE.LABEL.toUpperCase();
      },

      displayCurrency() {
        const data = this.columnHeaders &&
          this.columnHeaders.length &&
          this.columnHeaders.find(item => {
            return (
              item &&
              item.axisLabel &&
              item.axisLabel.toUpperCase() === this.AVE_LABEL
            );
        });

        return data;
      },

      columnsHaveTags() {
        return (
          this.query.columns &&
          this.query.columns.length &&
          this.query.columns[0].type === this.FILTER_TYPE_TAG
        );
      },

      rowsHaveTags() {
        return (
          this.query.rows &&
          this.query.rows.length &&
          this.query.rows[0].type === this.FILTER_TYPE_TAG
        );
      },

      projectId() {
        return this.$route.params.project_id;
      },

      queryId() {
        return this.$route.params.query_id;
      },

      draggingPlaceHolderText () {
        return this.dragging ? this.$i18n.t('drop_here') : '';
      },

      columnsCount () {
        return this.columns && this.columns.length > 0 || this.columnHeaders.length > 1 ? this.columnHeaders.length : this.queryOutputs.length || 5
      },

      rowsCount () {
        return this.rows && this.rows.length > 0 && !this.rowsAwaitingData ? this.rowHeaders.length : 9
      },

      sortIconClass() {
        let sortIconClass = 'fad fa-sort'
        if(!this.query.rankSort) {
          if(this.query.sort === 'asc') sortIconClass += '-up'
          if(this.query.sort === 'desc') sortIconClass += '-down'
        }
        // specific for the reversed rank sort
        else sortIconClass += this.query.sort && (this.query.sort === 'desc' ? '-up' : '-down') || ''; 
        return sortIconClass
      },

      sortTooltipText () {
        const isTimeBreakdown = this.rows[0] && this.rows[0].breakdown_name === 'Time';
        let rankSort;
        // specific for the reversed rank sort
        if(this.query.rankSort) rankSort = this.query.sort && (this.query.sort === 'desc' ? 'asc' : 'desc'); 
        return this.$i18n.t('sort_options.' + (rankSort || this.query.sort || (isTimeBreakdown ? 'date' : 'default')));
      }
    },

    created () {
      if (this.queryResult && this.queryResult.data && this.queryResult.data.data.length === 0) {
        this.noData = true;
      }

      if (_.get(this.queryResult, 'data.data') && this.queryResult.data.data.length > 0) {
        this.loadResult(this.queryResult.data.data);
      }
      else {
        //load both axis
        this.loadAxis('columns', this.columns || []);

        if(this.rowHeaders && this.rowHeaders.length === 0 && this.rows && this.rows.length > 0) {
          this.loadAxis('rows', this.rows);
        }
      }

      this.getProject({ projectUid: this.$route.params.project_id });
    },

    watch: {
      queryOutputs: {
        handler () {
          if (this.tableData && Object.keys(this.tableData).length > 0) {
            this.$emit('onRun');
          }
          else {
            this.loadAxis('columns', this.columns || []);

            if (this.rowHeaders && this.rowHeaders.length === 0 && this.rows && this.rows.length > 0) {
              this.loadAxis('rows', this.rows);
            }
          }
        }
      },

      displayCurrency: {
        handler () {
          if (this.displayCurrency)
            this.getCurrency({ projectId: this.projectId });
        },
        deep: true,
      },

      'fullCategory.data': {
        handler(value) {
          if ((this.columnsAwaitingData && this.columnsAwaitingData.type === 'category') || (this.rowsAwaitingData && this.rowsAwaitingData.type === 'category')) {
            const data = value?.data || {};
            let axis = false;
            if (this.columnsAwaitingData && this.columnsAwaitingData.type === 'category' && this.columnsAwaitingData.id === data.id) {
              axis = 'columns';
            }
            else if (this.rowsAwaitingData && this.rowsAwaitingData.type === 'category' && this.rowsAwaitingData.id === data.id) {
              axis = 'rows';
            }

            if (axis) {
              this.setAxisHeaders(axis, data.tags.map(data => {
                data.axisLabel = data.name;
                data.type = this.FILTER_TYPE_TAG;
                return data;
              }));

              this[axis + 'AwaitingData'] = false;
            }
          }
        }
      },

      'fullStandardBreakdown.data': {
        handler(value) {
          if ((this.columnsAwaitingData && this.columnsAwaitingData.type === 'standardBreakdown') || (this.rowsAwaitingData && this.rowsAwaitingData.type === 'standardBreakdown')) {
            let axis = false;
            if (this.columnsAwaitingData && this.columnsAwaitingData.type === 'standardBreakdown' && this.columnsAwaitingData.id === value.id) {
              axis = 'columns';
            }
            else if (this.rowsAwaitingData && this.rowsAwaitingData.type === 'standardBreakdown' && this.rowsAwaitingData.id === value.id) {
              axis = 'rows';
            }

            if (axis) {
              this.setAxisHeaders(axis, _.orderBy(value.sub_options, ['order']).map(data => {
                data.axisLabel = data.name;
                data.type = 'breakdown';
                return data;
              }));

              this[axis + 'AwaitingData'] = false;
            }
          }
        },
        deep: true
      },

      'queryResult.data': {
        handler (value) {
          if (value) {
            const data = _.get(value, 'data.data') || value.data;
            if (data && data.length > 0) {
              this.columnsAwaitingData = false;
              this.rowsAwaitingData = false;

              this.noData = false;
              this.loadResult(data);
            }
            else {
              this.noData = true;
              this.noDataError = value.error;
            }
          }
        },
        deep: true
      },

      outputs: {
        handler() {
          this.loadAxis('columns', this.columns || []);
        },
        deep: true
      },

      rows: {
        handler (value) {
          this.loadAxis('rows', value || []);
        }
      },

      columns: {
        handler (value) {
          this.loadAxis('columns', value || []);
        }
      }
    },

    methods: {
      ...mapActions({
        getProject: 'projects/getProject',
        'getFullCategory': 'queryBuilder/category/getFullCategory',
        'getFullStandardBreakdown': 'queryBuilder/standardBreakdown/getFullStandardBreakdown',
        getCurrency: 'projects/getCurrency'
      }),

      loadResult (data) {
        let rowNameAttribute = this.getRowName(data);
        let columnHeaders = (_.get(data, '[0].series') || []).map(column => {
          return {
            ...{axisLabel: column?.displayName || column.name},
            ...column
          }
        });
        this.setAxisHeaders('columns', columnHeaders, true);

        let rowHeaders = data.map(row => {
          return {
            ...{axisLabel: row[rowNameAttribute]},
            ...row
          }
        });
        this.setAxisHeaders('rows', rowHeaders);


        let table = {};
        data.map((row, i) => {
          if (!table[row[rowNameAttribute] + "_" + i]) {
            table[row[rowNameAttribute] + "_" + i] = {};
          }
          row.series.map((column, j) => {
            table[row[rowNameAttribute] + "_" + i][(column?.displayName || column.name) + "_" + j] = column.value;
          });
        });
        this.tableData = table;
      },

      getRowName (data) {
        if (data && data[0] && data[0].name) {
          return 'name';
        }

        return data && data[0] && _.find(Object.keys(data[0]), (key) => {
          return _.isString(data[0][key]) && ['id', 'type'].indexOf(key) === -1;
        });
      },

      isDefault(header) {
        return header.output_id === this.query.default_output
      },

      isMostRecentRange(header) {
        return !!header?.range?.mostRecentRange;
      },

      setOrderOnQuery(header) {
        if(!this.query.hasOwnProperty('order') || (this.query.hasOwnProperty('order') && Object.entries(this.query.order).length === 0)) {
          this.$emit('onPaginationChange', 'order', header);
        }
      },

      setSortOnQuery() {
        let sortOrder = 'desc'
        if(this.query.sort && this.query.sort === 'desc') sortOrder = 'asc'
        if(this.query.sort && this.query.sort === 'asc') sortOrder = 'desc'
        this.$emit('onPaginationChange', 'sort', sortOrder);
      },

      setOrderBy(header) {
        if(!this.isDefault(header)) return
        if(this.query.sort === 'asc') {
          this.setDefaultSort();
        } else {
          this.setOrderOnQuery(header);
          this.setSortOnQuery();
        }

        if(this.rows && this.rows.length > 0) {
          this.$emit('onRun', {query: this.query, pagination: this.queryPagination});
        }
      },

      setDefaultSort() {
        this.$emit('onPaginationChange', 'order', {});
        this.$emit('onPaginationChange', 'sort', '');
      },

      deleteColumns () {
        if(this.columns.length === 0)
          return;

        //Reload Axis
        this.loadAxis('columns', []);

        //Set query state
        this.$emit('setQueryEntity', {entity: 'columns', value: []});

      },

      clearResultData () {
        this.tableData = {};
        this.noData = false;
      },

      onDropColums (e) {
        if (_.get(this.blocked, 'columns') || !this.dragging || !e.dataTransfer.getData('filters')) {
          return;
        }

        if (this.queryPagination.order) {
          this.setDefaultSort();
        }

        const filter = JSON.parse(e.dataTransfer.getData('filters'));
        //Reload Axis
        this.loadAxis('columns', filter);

        //Set query state
        this.$emit('setQueryEntity', {entity: 'columns', value: filter})
        this.onDrop();
      },

      onDropRows (e) {
        if (_.get(this.blocked, 'rows') || !this.dragging || !e.dataTransfer.getData('filters')) {
          return;
        }

        if (this.queryPagination.order) {
          this.setDefaultSort();
        }

        const filter = JSON.parse(e.dataTransfer.getData('filters'));
        //Reload Axis
        this.loadAxis('rows', filter);

        //Set query state
        this.$emit('setQueryEntity', {entity: 'rows', value: filter})
        this.onDrop();
      },

      loadAxis (axis, axisFilters) {
        //clear result data
        this.clearResultData();

        let headingList = [];
        // check what there is in the axis filter
        axisFilters.map(filter => {
          switch (filter.type) {
            case this.FILTER_TYPE_TAG:
              filter.axisLabel = filter.tag_name;
              //if tag, add tag header string
              headingList.push(filter);
              break;
            case 'category':
              // if category and already loaded add tag
              // otherwise load tags and wait for response
              if (this.fullCategory && this.fullCategory.data && filter.id === this.fullCategory.data.id) {
                this.fullCategory.data.tags.map(tag => {
                  tag.axisLabel = tag.name;
                  tag.type = this.FILTER_TYPE_TAG;
                  headingList.push(tag);
                });
              }
              else {
                this.getCategoryTags(filter, axis);
              }
              break;
            case 'breakdown':
              // if breakdown, get children
              // if they are available add tag header string
              if (filter.expandable || filter.has_children) {
                // else load get children and wait for response
                if (this.fullStandardBreakdown && this.fullStandardBreakdown.data && this.fullStandardBreakdown.data.id === filter.id && this.fullStandardBreakdown.data.sub_options && this.fullStandardBreakdown.data.sub_options.length > 0) {
                  _.orderBy(this.fullStandardBreakdown.data.sub_options, ['order']).map(data => {
                    data.axisLabel = data.name;
                    data.type = 'breakdown';
                    headingList.push(data);
                  });
                }
                else if(filter.value === 'text' && !this.queryId) {
                  let textOptions = _.cloneDeep(this.localTextOptions);
                  if(textOptions) {
                    if (_.get(this.queryPagination, 'perPage')) {
                      textOptions = textOptions.splice(0, this.queryPagination.perPage);
                    }
                    textOptions = textOptions.map(data => {
                      data.axisLabel = data.name;
                      data.type = 'breakdown';
                      headingList.push(data);
                    });
                  }
                }
                else {
                  this.getBreakdownChildren(filter, axis);
                }
              }
              else {
                const newFilter = _.cloneDeep(filter);

                newFilter.axisLabel = filter.name;
                newFilter.type = 'breakdown';
                //if tag, add tag header string
                headingList.push(newFilter);
              }
              break;
          }
        });

        this.setAxisHeaders(axis, headingList);
      },

      setAxisHeaders (axis, headingList, isResult = false) {
        //set data variable for column or row axis
        if (axis === 'columns') {
          //if columns add the outputs with the array
          if (!isResult) {
            this.queryOutputs.map(outputId => {

              let output = (this.outputs || []).find(output => output.output_id === outputId);
              if (output) {
                output.axisLabel = output.name;
                headingList.push(output);
              }
            });
          }

          // Move the "rank" object to the first index if it exists, not to get reversed while sorting/loading
          const rankIndex = headingList.findIndex(col => col?.name?.toLocaleLowerCase() === 'rank');
          if (rankIndex > 0) {
            const [rankObj] = headingList.splice(rankIndex, 1);
            headingList.unshift(rankObj);
          }

          this.columnHeaders = headingList;
        }
        else {
          this.rowHeaders = headingList;
        }
      },

      removeElement({ entity, item }) {
        this.$emit('removeElement', { entity, item });
      },

      getBreakdownChildren (breakdown, axis) {
        this[axis + 'AwaitingData'] = {type: 'standardBreakdown', id: breakdown.id};

        this.getFullStandardBreakdown({
          projectId: this.projectId,
          queryId: this.queryId,
          breakdownId: breakdown.id,
          pagination: this.queryPagination.perPage < 0 ? {} : {perPage: this.queryPagination.perPage || 10}
        });
      },

      getCategoryTags (category, axis) {
        this[axis + 'AwaitingData'] = {type: 'category', id: category.id};

        const pagination = this.queryPagination.perPage < 0 ? {} : {perPage: this.queryPagination.perPage || 10};
        if (category.sub_category_id) {
          pagination.sub_category_id = category.sub_category_id;
        }

        this.getFullCategory({
          projectId: this.projectId,
          categoryId: category.id,
          pagination: pagination
        });
      },

      openArticleList ({rowHeader, columnHeader}) {
        delete rowHeader.axisLabel;
        delete columnHeader.axisLabel;
        this.$emit('onShowArticleList', {rowHeader, columnHeader});
      },

      formatDateRanges(date) {
        if(!date) return '';
        return moment(date).format('DD/MM/YYYY');
      }
    },
    data () {
      return {
        columnHeaders: [],
        rowHeaders: [],
        columnsAwaitingData: false,
        rowsAwaitingData: false,
        tableData: {},
        noDataError: "",
        noData: false
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/components/coding-queries/query-table.scss";
</style>